require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-scheduled-maintenance.json") })
        }
      }, "path---articles-scheduled-maintenance");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-scheduled-maintenance!./.cache/json/articles-scheduled-maintenance.json
// module id = 1730
// module chunks = 231608221292675